export default __webpack_public_path__ + "static/media/item1.ac415fc9.jpg";